import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n, usePageTitle } from '../../i18n/index.jsx';
import { CtaBand } from './Home.jsx';
import PageHero from '../../components/PageHero.jsx';
import { useContent } from '../../content.jsx';
import RichText from '../../components/RichText.jsx';
import { typoProps, useTypoFonts } from '../../richText.js';

export default function About() {
  const { t, tm } = useI18n();
  const { text, value } = useContent('about');
  const typo = value('typo', null);
  useTypoFonts(typo);
  const tp = typoProps(typo);
  usePageTitle('nav.about');
  // Published rich text (Admin > Website content > About) replaces the
  // built-in sections; sanitized on the server.
  const body = text('body');

  return (
    <div className={tp.className || undefined} style={tp.style}>
      <PageHero title={text('title', 'about.title')} lead={text('lead', 'about.lead')} />

      {body ? (
        <section className="section">
          <div className="container"><RichText className="about-body" value={body} /></div>
        </section>
      ) : (<>

      <section className="section">
        <div className="container prose-grid">
          {tm('about.sections').map((s) => (
            <article key={s.h} className="prose-block">
              <h2>{s.h}</h2>
              <p>{s.p}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <header className="section-head"><h2>{t('about.valuesTitle')}</h2></header>
          <div className="tile-grid tile-grid-3">
            {tm('about.values').map((v) => (
              <div className="tile" key={v.t}>
                <h3>{v.t}</h3>
                <p className="muted">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      </>)}

      <CtaBand title={text('ctaTitle', 'about.ctaTitle')} text={text('ctaText', 'about.ctaText')}>
        <Link className="btn btn-primary btn-lg" to="/contact">{t('home.ctaContact')}</Link>
      </CtaBand>
    </div>
  );
}
